/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientEncounterPartHistoryModel } from '../../models/patient-encounter-part-history-model';

export interface PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Params {
  patientId: string;
  anatomyPartId: string;
  startDate?: string | null;
  endDate?: string | null;
  facilityId: string;
}

export function patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet(http: HttpClient, rootUrl: string, params: PatientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientEncounterPartHistoryModel>>> {
  const rb = new RequestBuilder(rootUrl, patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.path('anatomyPartId', params.anatomyPartId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<PatientEncounterPartHistoryModel>>;
    })
  );
}

patientFacilityIdPatientEncounterPartHistoryPatientIdAnatomyPartIdGet.PATH = '/Patient/{facilityId}/PatientEncounterPartHistory/{patientId}/{anatomyPartId}';
